<lib-spinner *ngIf="loading"></lib-spinner>
<lib-user-management #userManagement [electronicID]=electronicID [delete]="false" [(selectedUser)]="selectedUser">
  <lib-dba-mat-table-button title="Löschen" (click)="OnUserDelete()" [disabled]="!selectedUser">
  </lib-dba-mat-table-button>
</lib-user-management>
